
/** @format */
import { Grid, Typography, Avatar } from '@mui/material';
import { useStyles } from './Style';
import { PageContainer } from 'components';
import { useNavigate, useLocation } from 'react-router-dom';
import { constBreadCrumbsTitle } from 'utility';

export default function SubsetDetail() {
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();
  const { subset } = location?.state || [];
 

  return (
    <PageContainer
      title="جزییات کسب‌وکار"
      onBackClick={() => navigate(-1)}
      breadcrumbs={constBreadCrumbsTitle.SUBBSET_DETAILS}
      className={classes.root}
    >
      <Grid container direction="row" alignItems="center" item>
        <Grid item xs={12}>
          <Typography className={classes.title}>{subset?.name}</Typography>
          <Grid container xs={12} md={9} className={classes.info}>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شناسه</Typography>
              <Typography className={classes.detailValue}>{subset?.id}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>نام کاربری</Typography>
              <Typography className={classes.detailValue}>{subset?.username}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>تصویر</Typography>
              <Typography className={classes.detailValue}>
                <Avatar alt="تصویر" src={subset?.image} className={classes.avatar} />
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>وضعیت</Typography>
              <Typography className={classes.detailValueFa}>
                {subset?.active ? 'فعال' : 'غیرفعال'}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>ایمیل</Typography>
              <Typography className={classes.detailValue}>{subset?.email}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شناسه کاربری</Typography>
              <Typography className={classes.detailValue}>{subset?.userId}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.detail}>
              <Typography className={classes.detailTitle}>آدرس</Typography>
              <Typography className={classes.detailValue}>
                {/* {subset.fullAddress} */}
                {`${subset?.country ? `${subset?.country} - ` : ''} ${subset?.city ? `${subset?.city} - ` : ''
                  } ${subset?.address ? subset?.address : ''}`}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.detail}>
              <Typography className={classes.detailTitle}>توضیحات</Typography>
              <Typography className={classes.detailValue}>{subset?.description}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageContainer>
  );
}
